import React from "react";

import styles from "./style.module.scss";
import SecondBg from "Utils/Assets/Images/Vector.png";
import cionimage from "Utils/Assets/Images/cionimage.png";
import cionimage1 from "Utils/Assets/Images/cionimage1.png";
import cionimage2 from "Utils/Assets/Images/cionimage2.png";
import CoinsVideo from "../../../Utils/Assets/Images/coins-rotating.webm";
import { useNavigate } from "react-router";

const CoinHeader = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.root}>
            <img
                src={SecondBg}
                alt="overlay"
                className={styles.HeaderOverlay}
            />

            <div className={styles.content}>
                <div className={styles.flex}>
                    <div className={styles.textContent}>
                        <h1>
                            Unlock the Power of MeetUsVR Coins
                        </h1>
                        <p className={styles.description}>
                            Earn, trade, and use digital assets within the
                            MeetUsVR ecosystem. Build your financial future in
                            the metaverse.
                        </p>
                        <div className={styles.btnHolder}>
                            <button
                                name="Download&StartEarningButton"
                                aria-label="Download & Start Earning"
                                className={`${styles.button} ${styles.downloadBtn}`}
                                onClick={() => navigate("/download-app")}
                            >
                                <p>Download & Start Earning</p>
                            </button>

                            <button
                                name="LearnMoreButton"
                                aria-label="Learn More"
                                className={`${styles.button} ${styles.learnMoreBtn}`}
                            >
                                <p>Learn More</p>
                            </button>
                        </div>
                    </div>
                    <div className={styles.videoWrapper}>
                        <video
                            src={CoinsVideo}
                            autoPlay
                            loop
                            muted
                            playsInline
                            className={styles.coinsVideo}
                            data-aos="fade-up"
                            data-aos-duration="800"
                        />

                        <div className={styles.coinsStack}>
                            <img
                                src={cionimage2}
                                alt="coin"
                                className={styles.coinImage2}
                            />
                            <img
                                src={cionimage1}
                                alt="coin"
                                className={styles.coinImage1}
                            />
                            <img
                                src={cionimage}
                                alt="coin"
                                className={styles.coinImage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoinHeader;
